import { render, staticRenderFns } from "./InsuranceBridgeConfirmFeedback.vue?vue&type=template&id=7574b564&scoped=true&"
import script from "./InsuranceBridgeConfirmFeedback.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeConfirmFeedback.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBridgeConfirmFeedback.vue?vue&type=style&index=0&id=7574b564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7574b564",
  null
  
)

export default component.exports